// src/pages/RestaurantPOS/manager/ContinentalManagerDashboard.jsx
import React from 'react';
import ManagerDashboard from './ManagerDashboard';

const ContinentalManagerDashboard = () => {
  return <ManagerDashboard locationKey="continental" />;
};

export default ContinentalManagerDashboard;